/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

EnergyCostSavingsService.$inject = [
    '$q',
    'UserApiConsumerService',
    'ProductApiConsumerService',
    'UtilService',
    'CookiesService',
    'GetFetchService'
];
function EnergyCostSavingsService(
    $q,
    UserApiConsumerService,
    ProductApiConsumerService,
    UtilService,
    CookiesService,
    GetFetchService
) {

    var _pub = {};
    var _costSavingDropDowns = {};
    var _costSavingDropDownsPromises = {};
    var _userUtilityRate = {};
    var _userCookieUtilityRate = {};
    var _userCookieUtilityRateValue = {};
    var _costSavingsUpdatedCallbacks = [];

    _pub.FUEL_TYPE_GAS = 'gas';

    /**
     * Fetches the calculation initial data for the cost savings dropdowns
     *
     * @param categoryId
     * @returns {$q.promise}
     */
    _pub.fetchCostSavingsInitialData = function(categoryId) {
        if (!_costSavingDropDownsPromises[categoryId]) {
            _costSavingDropDownsPromises[categoryId] = ProductApiConsumerService.get('api/1.0/cost-savings/efficiency-dropdowns/' + categoryId + '/').then(function (response) {
                _costSavingDropDowns[categoryId] = response.data;
            });
        }
        return _costSavingDropDownsPromises[categoryId];
    };

    /**
     * Fetches utility rate or user set custom electrical rate for registered user
     *
     * @returns {*}
     */

    _pub.fetchUserUtilityRate = function () {
        var urlOptions = {
            url: 'api/1.0/user-profile/electrical-utility/',
            requestingService: UserApiConsumerService.request
        };
        return GetFetchService.get('user-profile-electrical-utility', urlOptions).then(function (response) {
                if (response.data.electrical_rate !== null) {
                    _userUtilityRate = response.electrical_rate;
                } else if (response.data.user_set_electrical_rate !== null) {
                    _userUtilityRate = response.user_set_electrical_rate;
                }
            }, function () {
                _userUtilityRate = {};
        });
    };

    /**
     * Fetches utility rate from cookie
     * and use the default rate if no rate is found in cookie storage
     *
     * @returns {*}
     */

    _pub.fetchCookieUserUtilityRate = function () {
        _userCookieUtilityRateValue = CookiesService.get('user-utility');
        _userCookieUtilityRate = _userCookieUtilityRateValue ? parseFloat(_userCookieUtilityRateValue) : UtilService.getSiteSetting('default_electricity_rate');
        return _userCookieUtilityRate;

    };

    /**
     * Fetches the cost saving calculated value based on the dropdown's selected values
     *
     * @param dropdownChoice
     * @param costSavingsYears
     * @param costSavingsUsage
     * @param rateTextfield
     * @param productId
     * @returns {*}
     */
    _pub.getCostSavingCalculations = function(dropdownChoice, costSavingsYears, costSavingsUsage, rateTextfield, productId) {
        var options = {
            'method': 'GET',
            'url':  ProductApiConsumerService.getFullUrl('/api/1.0/cost-savings/' + dropdownChoice + '/' + productId + '/'),
            'params': {
                "cost_savings_years": costSavingsYears,
                "cost_savings_usage": costSavingsUsage,
                "rate_textfield": rateTextfield
            }
        };
        return GetFetchService.get(['cost-savings', dropdownChoice, productId, JSON.stringify(options.params)], options).then(function (response) {
            var calculations = response;
            calculations.choice = dropdownChoice;
            executeCostSavingsUpdatedCallbacks(calculations);
            return calculations;
        }, function () {
            return {};
        });
    };

    /**
     * returns the initial values of the cost savings drop downs
     *
     * @param {Number} categoryId
     * @returns {$q.promise}
     */
    _pub.getCostSavingsData = function(categoryId) {
        var deferred = $q.defer();
        if (_costSavingDropDowns[categoryId]) {
            deferred.resolve(_costSavingDropDowns[categoryId]);
        } else {
            _pub.fetchCostSavingsInitialData(categoryId).then(function() {
                deferred.resolve(_costSavingDropDowns[categoryId]);
            });
        }
        return deferred.promise;

    };

    /**
     * returns user's utility rate
     *
     * @returns {{}}
     */
    _pub.getUserUtilityRate = function () {

        return _userUtilityRate;

    };

    _pub.onCostSavingsCalculationsUpdated = function (event) {
        _costSavingsUpdatedCallbacks.push(event);
    };

    var executeCostSavingsUpdatedCallbacks = function (calculations) {
        _costSavingsUpdatedCallbacks.forEach(function (callback) {
            callback(calculations);
        });
    };

    return _pub;
}

module.exports = EnergyCostSavingsService;
